"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChooseLocationContext = exports.ChooseLocationProvider = exports.ChooseLocationContext = exports.ChooseLocatioActionType = exports.initialState = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable @typescript-eslint/no-explicit-any */
const React = require("react");
exports.initialState = {
    selectedCountry: {},
    currentCountry: {},
    countries: [],
    selectedLanguageUrl: '',
    searchTerm: '',
    dictionary: {},
    isCountryMenuOpened: true,
    isLanguageMenuOpened: false,
    isLanguageButtonOpened: false,
    isNotFound: false,
};
var ChooseLocatioActionType;
(function (ChooseLocatioActionType) {
    ChooseLocatioActionType["SHOW_LANGUAGE_MENU_WITH_CURRENT_LANGUAGE"] = "SHOW_LANGUAGE_MENU_WITH_CURRENT_LANGUAGE";
    ChooseLocatioActionType["SET_FIRST_LANGUAGE_URL_SELECTED"] = "SET_FIRST_LANGUAGE_URL_SELECTED";
    ChooseLocatioActionType["COUNTRIES_NOT_FOUND"] = "COUNTRIES_NOT_FOUND";
    ChooseLocatioActionType["COUNTRIES_FOUND"] = "COUNTRIES_FOUND";
    ChooseLocatioActionType["SET_COUNTRIES"] = "SET_COUNTRIES";
    ChooseLocatioActionType["RESET_SEARCH"] = "RESET_SEARCH";
    ChooseLocatioActionType["SET_SEARCH_TERM"] = "SET_SEARCH_TERM";
    ChooseLocatioActionType["SEARCH_INPUT_ON_FOCUSED"] = "SEARCH_INPUT_ON_FOCUSED";
    ChooseLocatioActionType["SET_SELECTED_COUNTRY"] = "SET_SELECTED_COUNTRY";
    ChooseLocatioActionType["OPEN_LANGUAGE_MENU"] = "OPEN_LANGUAGE_MENU";
    ChooseLocatioActionType["SET_SELECTED_LANGUAGE_URL"] = "SET_SELECTED_LANGUAGE_URL";
})(ChooseLocatioActionType || (exports.ChooseLocatioActionType = ChooseLocatioActionType = {}));
const headerReducer = (state, action) => {
    switch (action.type) {
        case ChooseLocatioActionType.SHOW_LANGUAGE_MENU_WITH_CURRENT_LANGUAGE:
            return Object.assign(Object.assign({}, state), { selectedLanguageUrl: state.currentCountry.currentLanguageUrl, searchTerm: state.selectedCountry.countryName, isCountryMenuOpened: false, isLanguageMenuOpened: true, isLanguageButtonOpened: true });
        case ChooseLocatioActionType.SET_FIRST_LANGUAGE_URL_SELECTED:
            return Object.assign(Object.assign({}, state), { selectedLanguageUrl: state.selectedCountry.url });
        case ChooseLocatioActionType.COUNTRIES_NOT_FOUND:
            return Object.assign(Object.assign({}, state), { isNotFound: false });
        case ChooseLocatioActionType.COUNTRIES_FOUND:
            return Object.assign(Object.assign({}, state), { isNotFound: true });
        case ChooseLocatioActionType.SET_COUNTRIES:
            return Object.assign(Object.assign({}, state), { countries: action.payload });
        case ChooseLocatioActionType.RESET_SEARCH:
            return Object.assign(Object.assign({}, state), { searchTerm: '', isLanguageMenuOpened: false });
        case ChooseLocatioActionType.SET_SEARCH_TERM:
            return Object.assign(Object.assign({}, state), { searchTerm: action.payload });
        case ChooseLocatioActionType.SEARCH_INPUT_ON_FOCUSED:
            return Object.assign(Object.assign({}, state), { searchTerm: '', isCountryMenuOpened: true, isLanguageButtonOpened: false, isLanguageMenuOpened: false });
        case ChooseLocatioActionType.SET_SELECTED_COUNTRY:
            return Object.assign(Object.assign({}, state), { selectedCountry: action.payload, searchTerm: action.payload.countryName, isCountryMenuOpened: false, isLanguageButtonOpened: true });
        case ChooseLocatioActionType.OPEN_LANGUAGE_MENU:
            return Object.assign(Object.assign({}, state), { isLanguageMenuOpened: true });
        case ChooseLocatioActionType.SET_SELECTED_LANGUAGE_URL:
            return Object.assign(Object.assign({}, state), { selectedLanguageUrl: action.payload });
        default:
            return state;
    }
};
exports.ChooseLocationContext = React.createContext(null);
const ChooseLocationProvider = ({ passedState, children }) => {
    const updatedInitialState = Object.assign(Object.assign({}, exports.initialState), passedState);
    const [state, dispatch] = React.useReducer(headerReducer, updatedInitialState);
    const value = React.useMemo(() => ({ state, dispatch }), [state, dispatch]);
    return (0, jsx_runtime_1.jsx)(exports.ChooseLocationContext.Provider, { value: value, children: children });
};
exports.ChooseLocationProvider = ChooseLocationProvider;
const useChooseLocationContext = () => {
    const context = React.useContext(exports.ChooseLocationContext);
    if (!context) {
        throw new Error('useTodoContext must be used within a HeaderStateProvider');
    }
    return context;
};
exports.useChooseLocationContext = useChooseLocationContext;
